import { DialogContent } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { FC } from 'react';

export const CustomDialogContent: FC<React.PropsWithChildren<{}>> = (props) => {
  const isDesktop = useIsDesktop();

  return (
    <DialogContent
      sx={{
        padding: isDesktop ? '24px 64px 16px' : '10px 20px',
        marginTop: '24px',
        height: isDesktop ? undefined : '70vh',
        zIndex: '1',
        overflowY: 'auto',
      }}
    >
      {props.children}
    </DialogContent>
  );
};
